<script>
  import AtomImage from "@/components/atoms/AtomImg.vue";

  export default {
    name: "PlatformHeader",
    components: { AtomImage },
    props: {
      name: String,
      icon: String,
      open: { type: Boolean, default: false },
      showBtn: { type: Boolean, default: true },
    },
  };
</script>

<template>
  <header class="platform-header" :class="{ 'platform-header--open': open }">
    <AtomImage class="platform-header__icon" :src="icon" alt="" width="20" height="20" :styles="{ borderRadius: '4px' }" />

    <span class="platform-header__name">{{ name }}</span>

    <iconic v-if="!showBtn" class="platform-header__chevron" name="chevron" aria-hidden="true" :aria-expanded="open.toString()" @click.native="$emit('toggle')" />
  </header>
</template>

<style lang="scss" scoped>
  .platform-header {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    user-select: none;

    &__name {
      flex: 1;
      font-family: $newFont_semiBold;
      font-weight: 600;
      font-size: 16px;
      color: #212121;
    }

    &__chevron {
      transition: transform 0.2s ease;
      font-size: 14px;
      transform: rotate(0deg);
    }

    &--open {
      .platform-header__chevron {
        transform: rotate(180deg);
      }
    }
  }
</style>
